import { List, fromJS } from 'immutable';

export function request(state, { userId }) {
    return state.setIn(['betslip-updated', userId], 'FINISHED');
}
